import { css } from "styled-components"
import { colors } from "../../helpers/colors"

export const DividerStyles = css`
  background: ${colors.greenblue};
`
